<template>
  <div class="p-5">
    <div class="container-fluid">
      <div class="row size-column">
        <div class="col-xxl-12 col-md-12 box-col-12 grid-ed-12">
          <div class="row">
            <div class="col-xxl-12 col-md-12 col-sm-12 box-col-12">
              <h6 class="mb-4">
                <b>Last Updated: </b
                ><span style="color: #03c04a"
                  >{{ formattedLastUpdated
                  }}<i
                    v-if="last_updated"
                    class="ml-1 fa fa-light fa-check-circle-o"
                    style="color: #03c04a"
                  ></i
                ></span>
              </h6>
              <h2 class="fw-bold">Footer</h2>
              <p>
                Edit the bottom section of the website below and don't forget to
                save your changes
              </p>
              <div class="card mb-5">
                <div class="card-body d-flex gap-3">
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <h5 class="mb-3">The footer location:</h5>
                    <div class="mb-5 footer-location"></div>

                    <div class="mb-4">
                      <div style="display: flex; flex-direction: column">
                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                          "
                        >
                          <img
                            :src="image_slogan"
                            style="
                              width: 120px;
                              height: 120px;
                              object-fit: contain;
                              border-radius: 10px;
                              border: dashed 1px gray;
                            "
                          />
                          <div
                            class="fileUpload bg-none text-left align-middle d-block"
                          >
                            <div>
                              <span class="media-text p-2"
                                >Select from Media Library (Max dimension 1200 x
                                800 px)</span
                              >
                            </div>
                            <button
                              @click="openGalleryModal('footer_image')"
                              aria-hidden="true"
                              class="mx-2 p-2 border w-auto"
                            >
                              Upload File
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="mb-5">
                      To edit social media accounts, navigate to
                      <span class="fw-bold">Settings > Social Media</span>
                    </p>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="container">
                      <h5 class="mb-3 fw-bold">Google Playstore</h5>
                      <div class="mb-4">
                        <div style="display: flex; flex-direction: column">
                          <div
                            style="
                              display: flex;
                              flex-direction: row;
                              align-items: center;
                            "
                          >
                            <img
                              :src="image_google_play"
                              style="
                                width: 120px;
                                height: 120px;
                                object-fit: contain;
                                border-radius: 10px;
                                border: dashed 1px gray;
                              "
                            />
                            <div
                              class="fileUpload bg-none text-left align-middle d-block"
                            >
                              <div>
                                <span class="media-text p-2"
                                  >Select from Media Library (Max dimension 1200
                                  x 800 px)</span
                                >
                              </div>
                              <button
                                @click="openGalleryModal('google_play')"
                                aria-hidden="true"
                                class="mx-2 p-2 border w-auto"
                              >
                                Upload File
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-5">
                        <label for="google-url" class="col-sm-1">URL</label>
                        <div class="col-sm-9">
                          <input
                            class="form-control border-dark"
                            type="text"
                            id="google-url"
                            placeholder="https://"
                            v-model="formattedGoogleStoreUrl"
                          />
                        </div>
                      </div>

                      <h5 class="mb-3 fw-bold">Apple Store URL</h5>
                      <div class="mb-4">
                        <div style="display: flex; flex-direction: column">
                          <div
                            style="
                              display: flex;
                              flex-direction: row;
                              align-items: center;
                            "
                          >
                            <img
                              :src="image_app_store"
                              style="
                                width: 120px;
                                height: 120px;
                                object-fit: contain;
                                border-radius: 10px;
                                border: dashed 1px gray;
                              "
                            />
                            <div
                              class="fileUpload bg-none text-left align-middle d-block"
                            >
                              <div>
                                <span class="media-text p-2"
                                  >Select from Media Library (Max dimension 1200
                                  x 800 px)</span
                                >
                              </div>
                              <button
                                @click="openGalleryModal('app_store')"
                                aria-hidden="true"
                                class="mx-2 p-2 border w-auto"
                              >
                                Upload File
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mb-5">
                        <label for="apple-url" class="col-sm-1">URL</label>
                        <div class="col-sm-9">
                          <input
                            class="form-control border-dark"
                            type="text"
                            id="apple-url"
                            placeholder="https://"
                            v-model="formattedAppleStoreUrl"
                          />
                        </div>
                      </div>
                      <div>
                        <h5 class="md-3 fw-bold">Text</h5>
                        <textarea
                          class="form-control border-dark"
                          name=""
                          id=""
                          cols="10"
                          rows="5"
                          v-model="text"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-footer border-none">
                  <div class="d-flex justify-content-end">
                    <PrimaryButton
                      :disabled="false"
                      @click="saveFooterAndSave()"
                    >
                      Save
                    </PrimaryButton>
                  </div>
                </div>
                <ImageComponent @add-image="handleAddImage($event)" />
              </div>
            </div>
          </div>

          <div class="row">
            <h2 class="fw-bold mb-4">Bottom Navigation</h2>
            <div class="col-xxl-4 col-md-2 col-sm-2 box-col-2">
              <div class="appointment">
                <div class="card">
                  <div class="card-header">
                    <div class="header-top">
                      <h5 class="m-0 fw-bold">Pages</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <p>The maximum amount of selection is 4 items.</p>
                    <div class="pages-list">
                      <div
                        v-for="(pages, index) in pages"
                        :key="index"
                        class="col"
                      >
                        <label class="checkbox-row">
                          <input
                            type="checkbox"
                            v-model="pages.checked"
                            :disabled="
                              customizedMenu.length + selectedMenuCount >= 4 &&
                              !pages.checked
                            "
                          />
                          {{ pages.name }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="card-footer border-none d-flex justify-content-end"
                  >
                    <div>
                      <PrimaryButton @click="addToMenu"> + </PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xxl-8 col-md-10 col-sm-10 box-col-10">
              <div class="appointment">
                <div class="card">
                  <div class="card-header">
                    <div class="header-top">
                      <h5 class="m-0 fw-bold">Structure</h5>
                      <PrimaryButton
                        :disabled="false"
                        @click="saveFooterAndSave()"
                        class="w-100"
                        >Save
                      </PrimaryButton>
                    </div>
                  </div>
                  <div class="card-body pt-0">
                    <div class="mt-3 bottom-nav-structure"></div>
                    <p>
                      The menu location above is where you can make edits. Add
                      and drag items in the preferred order.
                    </p>

                    <draggable
                      :key="columnIndex"
                      :list="customizedMenu"
                      group="menuItems"
                    >
                      <template v-slot:item="{ element, index }">
                        <div class="menu-item">
                          <span class="index-number">{{
                            getMenuIndex(columnIndex, index)
                          }}</span>
                          {{ element.name }}
                          <button
                            @click="removeInput(element.id)"
                            class="remove-button"
                          >
                            x
                          </button>
                        </div>
                      </template>
                    </draggable>
                  </div>
                  <div class="card-header card-no-border py-0">
                    <div class="header-top">
                      <h5 class="fw-bold">Copyright</h5>
                    </div>
                  </div>
                  <div class="card-body">
                    <textarea
                      class="form-control border-dark"
                      name=""
                      id=""
                      cols="10"
                      rows="3"
                      v-model="copyright"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/PrimaryButton.vue";
import FileUploadComponent from "@/components/FileUploadComponent.vue";
import axios from "axios";
import draggable from "vuedraggable";
import { getRequest, patchRequest } from "@/services/RequestService";
import { ref, computed, onMounted } from "vue";
import ImageComponent from "@/components/ImageComponent.vue";
import dayjs from "dayjs";

export default {
  components: {
    PrimaryButton,
    FileUploadComponent,
    draggable,
    ImageComponent,
  },

  data() {
    return {
      googleStoreUrl: "",
      appleStoreUrl: "",
      image_slogan: "",
      image_google_play: "",
      image_app_store: "",
      customizedMenu: [],
      last_updated: "",
      last_updated_menu: "",
      last_updated_footer: "",
      galleryId: "",
      groupedItemsArr: [],
      dragging: false,
    };
  },
  computed: {
    formattedLastUpdated() {
      if (dayjs(this.last_updated_footer) > dayjs(this.last_updated_menu)) {
        this.last_updated = this.last_updated_footer;
      } else {
        this.last_updated = this.last_updated_menu;
      }

      console.log("latest: ", this.last_updated);
      const date = new Date(this.last_updated);
      const day = date.getDate();
      const month = date.getMonth() + 1; // Months are 0-indexed
      const year = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? "pm" : "am";
      return `${day}/${month}/${year}, ${hours % 12}:${minutes} ${ampm}`;
    },

    groupedMenuItems() {
      const maxItemsPerColumn = 4;
      const groupedItems = [];
      let currentColumn = [];

      this.customizedMenu.forEach((menu, index) => {
        if (index > 0 && index % maxItemsPerColumn === 0) {
          groupedItems.push(currentColumn);
          currentColumn = [];
        }
        currentColumn.push(menu);
      });

      if (currentColumn.length > 0) {
        groupedItems.push(currentColumn);
      }

      this.customizedMenu = groupedItems;

      return this.customizedMenu;
    },

    formattedGoogleStoreUrl() {
      return this.formattedUrl(this.googleStoreUrl);
    },
    formattedAppleStoreUrl() {
      return this.formattedUrl(this.appleStoreUrl);
    },
  },
  setup() {
    const pages = ref([]);

    const loadMenus = async () => {
      try {
        let response = await getRequest("/pages", true);

        if (response.data && response.data.data) {
          pages.value = response.data.data;

          // Initialize the 'checked' property for each menu item
          pages.value.forEach((page) => {
            page.checked = false;
          });
        } else {
          console.error("API response is missing data:", response);
        }
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    };

    const selectedMenuCount = computed(() => {
      return pages.value.filter((page) => page.checked).length;
    });

    onMounted(loadMenus);

    onMounted(() => {
      selectedMenuCount.value; // This line ensures that the computed property is properly initialized on component mount
    });

    return {
      pages,
      selectedMenuCount,
    };
  },
  methods: {
    loadMenu() {
      axios
        .get("/headers/4/view")
        .then((response) => {
          this.last_updated_menu = response.data.data.updated_at;

          // Extract menu items from the 'menus' array in the API response
          const menuItems = response.data.data.menus;

          // Map the menu items to the format expected in customizedMenu
          this.customizedMenu = menuItems.map((menuItem) => {
            return {
              id: menuItem.id,
              name: menuItem.name,
              // Add other properties as needed
            };
          });
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    loadFooter() {
      axios.get("/footers").then((response) => {
        this.googleStoreUrl = response.data.data.google_store;
        this.appleStoreUrl = response.data.data.apple_store;
        this.copyright = response.data.data.copyright;
        this.text = response.data.data.text;
        this.image_slogan = response.data.data.image_slogan;
        this.image_google_play = response.data.data.image_google_play;
        this.image_app_store = response.data.data.image_app_store;
        this.last_updated_footer = response.data.data.updated_at;
      });
    },
    addToMenu() {
      const selectedMenus = this.pages.filter((pages) => pages.checked);

      // Calculate the number of items already in the customized menu
      const existingItemsCount = this.customizedMenu.length;
      const remainingSlots = 4 - existingItemsCount; // Update to match the max limit

      // Add selected items to the customized menu if they're not already present
      selectedMenus.forEach((menu) => {
        if (
          this.customizedMenu.length < 4 &&
          !this.customizedMenu.includes(menu)
        ) {
          this.customizedMenu.push(menu);
        }
      });

      // Enable checkboxes if needed
      if (this.customizedMenu.length + this.selectedMenuCount < 4) {
        this.pages.forEach((pages) => {
          pages.checked = false;
        });
      }
    },

    removeInput(id) {
      const removedIndex = this.customizedMenu.findIndex(
        (pages) => pages.id === id
      );
      if (removedIndex !== -1) {
        this.customizedMenu.splice(removedIndex, 1);
      }

      // Enable checkboxes if needed
      if (this.customizedMenu.length + this.selectedMenuCount < 4) {
        this.pages.forEach((pages) => {
          pages.checked = false;
        });
      }
    },

    handleDragChange(evt) {
      const newGroupedMenuItems = [];
      for (const column of evt) {
        newGroupedMenuItems.push(column.map((item) => item));
      }
      this.groupedMenuItems = newGroupedMenuItems;
    },
    getMenuIndex(columnIndex, itemIndex) {
      let index = 0;
      for (let i = 0; i < columnIndex; i++) {
        index += this.groupedMenuItems[i].length;
      }
      return index + itemIndex + 1;
    },

    openGalleryModal(section) {
      console.log("Open Gallery for:", section);

      document.getElementById("modal_id").value = section;

      var galleryModal = document.getElementById("galleryModal");
      galleryModal.classList.add("show");
      galleryModal.style.display = "block";
    },

    handleAddImage(galleryId) {
      console.log(
        "Added image with ID:",
        galleryId,
        "For Section:",
        galleryId.modalName
      );

      if (galleryId.modalName == "footer_image") {
        this.image_slogan = galleryId.galleryUrl;
        this.image_slogan_image_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "google_play") {
        this.image_google_play = galleryId.galleryUrl;
        this.google_play_image_id = galleryId.galleryId;
      }
      if (galleryId.modalName == "app_store") {
        this.image_app_store = galleryId.galleryUrl;
        this.app_store_image_id = galleryId.galleryId;
      }
    },

    formattedUrl(url) {
      // Check if the URL is defined and starts with "https://", if not, append it
      if (url && typeof url === "string" && !url.startsWith("https://")) {
        return `https://${url}`;
      }
      return url;
    },

    async saveFooterAndSave() {
      try {
        const requestDataFooter = this._bottomNavRequest();
        const requestDataSave = this._footerRequest();

        // Kick off both asynchronous operations concurrently
        const [responseFooter, responseSave] = await Promise.all([
          this.saveData("/headers/4/update", requestDataFooter),
          this.saveData("/footers/update", requestDataSave),
        ]);

        // Handle responses as needed
        if (responseFooter.data.success) {
          // Handle success for saveFooter
          console.log("Save Footer success:", responseFooter.data.message);
        } else {
          // Handle error for saveFooter
          console.error("Save Footer error:", responseFooter.data.message);
        }

        if (responseSave.data.success) {
          // Handle success for save
          console.log("Save success:", responseSave.data.message);
        } else {
          // Handle error for save
          console.error("Save error:", responseSave.data.message);
        }
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    async saveData(endpoint, requestData) {
      try {
        let response = await patchRequest(endpoint, requestData, true);

        if (response.data.success) {
          this.$swal({
            icon: response.data.success ? "success" : "error",
            text: response.data.message,
            confirmButtonText: "Close",
          }).then(async () => {
            location.reload();
          });
        } else {
          this.$swal({
            icon: "error",
            text: "Incomplete details. Please complete the form.",
            confirmButtonText: "Close",
            confirmButtonColor: "#ffbc0d",
          });
        }

        if (response.data.success === false) {
          throw new Error("Something's not right. Please try again.");
        }

        console.log(response.data);
      } catch (error) {
        console.error("An error occurred:", error);
      }
    },

    _bottomNavRequest() {
      const menuIds = this.customizedMenu.map((menu) => menu.id);
      console.log("Menu IDs:", menuIds);
      return {
        structure: menuIds,
      };
    },

    _footerRequest() {
      return {
        image_lovin_it: this.image_slogan_image_id,
        image_google_store: this.google_play_image_id,
        google_store: this.formattedGoogleStoreUrl,
        image_apple_store: this.app_store_image_id,
        apple_store: this.formattedUrl(this.appleStoreUrl),
        text: this.text,
        copyright: this.copyright,
      };
    },
  },

  mounted() {
    this.loadMenu();
    this.loadFooter();
  },
};
</script>

<style scoped>
.pages-list {
  border: 1px solid #dadada;
  border-radius: 3%;
  padding: 10px;
}

.checkbox-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #dadada;
  border-radius: 5px;
  background-color: #f5f5f5;
  box-sizing: border-box;
  width: 20rem;
  margin-bottom: 10px;
}

.index-number {
  display: inline-block;
  margin-right: 5px;
  font-weight: bold;
  color: #333;
}

.order-number {
  margin-right: 10px;
}

.menu-list {
  margin-right: 10px;
  background-color: #dadada;
  border-radius: 10px;
  padding: 10px;
  width: 300px;
}

.remove-button {
  margin-left: auto;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  font-weight: bold;
  cursor: pointer;
}

.footer-location {
  height: 10rem;
  width: 80%;
  background-image: url("@/assets/images/admin/footer/Footer_Structure.svg");
  background-size: contain;
}

.bottom-nav-structure {
  height: 10rem;
  background-image: url("@/assets/images/admin/footer/Bottom_Nav_Structure.svg");
  background-size: contain;
}
</style>
